module.exports = __webpack_public_path__ + "static/img/product2-4.97ea444.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product2-4.jpg
// module id = ePzU
// module chunks = 0